<!-- 系统管理-菜单管理 -->
<template>
  <div >
    <!-- 卡片 -->
    <md-card>
      <!-- 卡片-主体 -->
      <md-card-content>
        <div style="margin-bottom: 12px;">
          <md-button class="diy-blue has-button" @click="table_addItem">
            <md-icon>add</md-icon>
            {{$I18n("add_reg")}}
          </md-button>
        </div>
        <!-- 表格 -->
        <md-table class="diy-gray" v-model="tableData">
          <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="single">
            <md-table-cell :md-label="$I18n('equi_area_1')" class="numbers">{{ item.name }}</md-table-cell>
            <md-table-cell :md-label="$I18n('equi_area_3')"></md-table-cell>
            <md-table-cell :md-label="$I18n('equi_area_4')">{{ item.create_time }}</md-table-cell>
            <md-table-cell :md-label="$I18n('equi_area_5')"></md-table-cell>
            <md-table-cell :md-label="$I18n('mani')" class="button-cell">
              <div v-if="item.def!==1">
                <md-button @click="table_editItem(item)" @click.stop class="md-simple">
                  {{$I18n("compiler")}}
                </md-button>
                <md-button @click="table_deleteItem(item)" @click.stop class="md-simple">
                  {{$I18n("remove")}}
                </md-button>
              </div>
            </md-table-cell>
          </md-table-row>
          <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
        </md-table>
        <table-page :total="total" :pageSize="pageSize" @changePage="page => pageSize = page" v-model="currentPage"/>
      </md-card-content>
    </md-card>
    <!-- 弹窗 -->
    <modal-area  ref="modal" @close="close_modal" :sel_organi="sel_organi"/>
  </div>
</template>
<script>
import { timestampToString1000 } from "@/common/tools.js";
import ModalArea from "./ModalArea.vue";
export default {
  props:["sel_organi"],
  components: { ModalArea },
  data() {
    return {
      total       : 0,
      currentPage : 1,
      pageSize    : 10,
      noRepeat    : false,
      tableData : [], // 表格-展示数据

    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
    pageSize(){
      this.currentPage = 1;
      this.api_getPageData();
      this.noRepeat = true;
    },
    currentPage(){
      this.api_getPageData();
    },
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    api_getPageData(){ // API-获取主菜单信息
      if(this.noRepeat){
        return
      }
      //获取菜单
      this.$api.g_DevZone({
        home_id : this.sel_organi,
        page_no : this.currentPage,
        page_size: this.pageSize,
      })
        .then(this.$Then(res => {
          this.total = res.count;
          this.tableData = res.data.map(i => {
            return {
              ...i,
              create_time: timestampToString1000(i.gmt_create),
            }
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableData = [];
        }))
        .then(() => {
          this.noRepeat = false;
        })
    },
    table_addItem(){
      this.$refs.modal.open("add")
    },
    table_editItem(data){
      this.$refs.modal.open("edit", data)
    },
    table_deleteItem(data){
      this.$refs.modal.open("del", data)
    },
    close_modal(){
       this.currentPage = 1;
       this.api_getPageData();
    },
  },
}
</script>